import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const OktaTokenDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="okta token - nhi details view"
        />
      )}
      {entityData?.okta_token_data?.restrict_network_connection != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>
              Network zone restriction
            </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            {entityData?.okta_token_data?.restrict_network_connection !=
              null && (
              <TextIntegrationStyle
                title={""}
                value={
                  entityData?.okta_token_data?.restrict_network_connection
                    ? "Yes"
                    : "No"
                }
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default OktaTokenDetailsView;
